export default __webpack_public_path__ + "static/media/fmbmi-orange.254caedf.png";